import { CircleIcon } from './CircleIcon';

/**
 * author: Austin Andrews
 * id 59803983-F6CE-4D40-B83C-36D42C9464A9
 * name circle
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/circle.svg
 * tags
 * - Shape 
 */
export const LensIcon = CircleIcon;
export default LensIcon